import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useMemo, useState } from 'react';
import { getTestIds } from '../../../../utils/TestIds';
import { ConditionalWrapper } from '../../../ConditionalWrapper';
import { FullRow } from '../../../Layout';
import { Switch } from '../../../Switch';
import { Tooltip } from '../../../Tooltip';
import { Typography } from '../../../Typography';
import styles from './ColumnsPanel.module.scss';
export function ColumnsPanelRow(param) {
    let { entry, lockedTooltip, toggleBi, onToggleVisibility, testId } = param;
    const testIds = useMemo(()=>getTestIds(testId), [
        testId
    ]);
    const isPinnedOn = entry.isMain;
    const [isLockedSwitchHovered, setIsLockedSwitchHovered] = useState(false);
    return /*#__PURE__*/ _jsx(ConditionalWrapper, {
        condition: isPinnedOn,
        wrapper: (children)=>/*#__PURE__*/ _jsx(Tooltip, {
                title: lockedTooltip,
                placement: "left",
                open: isLockedSwitchHovered,
                children: /*#__PURE__*/ _jsx("div", {
                    className: styles.lockedEntry,
                    children: children
                })
            }),
        children: /*#__PURE__*/ _jsxs(FullRow, {
            alignItems: "center",
            gap: 8,
            className: styles.entry,
            testId: testIds.entry(entry.id),
            children: [
                /*#__PURE__*/ _jsx(Typography, {
                    variant: "paragraph2",
                    ellipsis: true,
                    className: styles.entryLabel,
                    children: entry.label
                }),
                /*#__PURE__*/ _jsx(ConditionalWrapper, {
                    condition: isPinnedOn,
                    wrapper: (children)=>/*#__PURE__*/ _jsx("span", {
                            className: styles.lockedToggle,
                            onMouseEnter: ()=>setIsLockedSwitchHovered(true),
                            onMouseLeave: ()=>setIsLockedSwitchHovered(false),
                            children: children
                        }),
                    children: /*#__PURE__*/ _jsx(Switch, {
                        bi: toggleBi,
                        checked: isPinnedOn || !entry.hidden,
                        disabled: isPinnedOn,
                        onChange: ()=>!isPinnedOn && onToggleVisibility(entry.id),
                        testId: testIds.visible(entry.id)
                    })
                })
            ]
        })
    });
}
